// Autogenerated file
export const tripSheetFactSourcesEnum = {
    Manual: "Manual",
    Telematics: "Telematics",
    Corrected: "Corrected",
    Bid: "Bid",
    ExternalSystem: "ExternalSystem",
    Migration: "Migration",
};
export const tripSheetFactSources = [
    { label: "Вручную", value: "Manual" },
    { label: "Телематика", value: "Telematics" },
    { label: "Скорректировано", value: "Corrected" },
    { label: "Заявка", value: "Bid" },
    { label: "Внешняя система", value: "ExternalSystem" },
    { label: "Миграция", value: "Migration" },
];
